import { CopyQuality } from "models/copyQualities"
import { http } from "./http"

export const fetchCopyQualities = async (_key: string) => {
  const { data } = await http
    .get(`copy-qualities`)
    .json<{ data: CopyQuality[] }>()
  return data
}

export const fetchCopyQuality = async (_key: string, id: string) => {
  const { data } = await http
    .get(`copy-qualities/${id}`)
    .json<{ data: CopyQuality }>()
  return data
}

export const createCopyQuality = async (pld: Partial<CopyQuality>) => {
  const { ...body } = pld
  return (await http
    .post(`copy-qualities`, { json: body })
    .json()) as CopyQuality
}

export const patchCopyQuality = async (
  pld: Partial<CopyQuality>,
): Promise<CopyQuality> => {
  const { id, ...data } = pld
  return (await http.patch(`copy-qualities/${id}`, { json: data })) as any
}

export const deleteCopyQuality = async (pld: { copyQualityId: string }) => {
  await http.delete(`copy-qualities/${pld.copyQualityId}`)
}

export const activateCopyQuality = async (pld: { copyQualityId: string }) => {
  return await http.post(`copy-qualities/${pld.copyQualityId}/activate`)
}

export const deactivateCopyQuality = async (pld: { copyQualityId: string }) => {
  return await http.post(`copy-qualities/${pld.copyQualityId}/deactivate`)
}
